export const setStatisticsApplicationFilter = payload => {
  return {
    type: "SET_STATS_APPLICATIONS_FILTER",
    payload
  };
};

export const setStatisticsEventsFilter = payload => {
  return {
    type: "SET_STATS_EVENTS_FILTER",
    payload
  };
};

export const setStatisticsYearFilter = payload => {
  return {
    type: "SET_STATS_YEAR_FILTER",
    payload
  };
};

export const setStatisticAppTypeFilter = payload => {

  return {
    type: "SET_STATISTIC_APP_TYPE_FILTER",
    payload
  };
}

export const getFacturationStatistics = payload => {
  return {
    type: "GET_FACTURATION_STATISTICS",
    payload
  };
};

export const getPaymentStatistics = payload => {
  return {
    type: "GET_PAYMENT_STATISTICS",
    payload
  };
};


export const getNotPaidInvoices = payload => {
  return {
    type: "GET_NOT_PAID_INVOICES",
    payload
  };
};


export const getRecapByDay = payload => {
  return {
    type: "GET_RECAP_BY_DAY",
    payload
  };
};

export const getInvoiceByEventDetails = payload => {
  return {
    type: "GET_PAID_INVOICE_APPLICATION_DETAILS",
    payload
  };
};


export const setFilterInvoicesByDay = payload => {
  return {
    type: "SET_FILTER_INVOICES_DAY",
    payload
  };
};

export const getUnpaidInvoicesDetails = payload => {
  return {
    type: "GET_UNPAID_INVOICES_DETAILS",
    payload
  };
};

export const setFilteredItems = payload => {
  return {
    type: "SET_FILTERED_ITEMS",
    payload
  };
};

export const setFilteredNotPaidItems = payload => {
  return {
    type: "SET_FILTERED_NOT_PAID_ITEMS",
    payload
  };
};


export const getDocumentsToBeExportedZipEfff = payload => {
  return {
    type: "GET_DOCUMENTS_TO_BE_EXPORTED_ZIP_EFFF",
    payload
  };
};

export const setFiltredDocumentsToBeExportedEfffZip = payload => {
  return {
    type: "SET_FILTERED_DOCUMENTS_TO_BE_EXPORTED_EFFF_ITEMS",
    payload
  };
};

export const startCommandExportEfffZip = payload => {
  return {
    type: "START_COMMAND_EXPORT_EFFF_ZIP",
    payload
  };
};

export const getDoublePayment = payload => {
  return {
    type: "GET_DOUBLE_PAYMENT",
    payload
  };
};

export const setFilteredDoublePaymentItems = payload => {
  return {
    type: "SET_FILTERED_DOUBLE_PAYMENT_ITEMS",
    payload
  };
};

export const removeDoublePaymentFromDatatable = payload => {
  return {
    type: "REMOVE_DOUBLE_PAYMENT",
    payload
  };
};

export const changeRefundedOrderStatus = payload => {
  return {
    type: "CHANGE_REFUNDED_ORDERS_STATUS",
    payload
  };
};

export const startCommandGetCANbrInscriptionByFormat = payload => {
  return {
    type: "START_COMMAND_GET_CA_NBR_INSCRIPTION_BY_FORMAT",
    payload
  };
};

export const startCommandCumulateByFormat = payload => {
  return {
    type: "START_COMMAND_CUMULATE_BY_FORMAT",
    payload
  };
}

export const getNbrCotisants = payload => {
  return {
    type: "GET_NBR_COTISANTS",
    payload
  };
}

export const getTypeFormats = payload => {
  return {
    type: "GET_TYPE_FORMATS",
    payload
  };
}

export const getNbrCotisantByFormat = payload => {
  return {
    type: "GET_NBR_COTISANT_BY_FORMAT",
    payload
  };
};

export const getCAByFormat = payload => {
  return {
    type: "GET_CA_BY_FORMAT",
    payload
  };
}

export const getCotisationMonths = payload => {
  return {
    type: "GET_COTISATION_MONTHS",
    payload
  };
};

export const getMembershipAssociative = payload => {
  return {
    type: "GET_MEMBERSHIP_ASSOCIATIVE",
    payload
  };
};
export const getActivePremium = payload => {
  return {
    type: "GET_ACTIVE_PREMIUM",
    payload
  };
}

export const getAccumulateStats = payload => {
  return {
    type: "GET_ACCUMULATE_STATS",
    payload
  };
}

export const getAccumulateEventStats = payload => {
  return {
    type: "GET_ACCUMULATE_EVENT_STATS",
    payload
  };
}

export const getNbrInscritsCAPaperByRegion = payload => {
  return {
    type: "GET_NBR_INSCRITS_CA_PAPER_BY_REGION",
    payload
  };
};

export const getRapportInscritsPaper = payload => {
  return {
    type: "GET_RAPPORT_INSCRITS_PAPER",
    payload
  };
};

export const getRapportCAPaper = payload => {
  return {
    type: "GET_RAPPORT_CA_PAPER",
    payload
  };
};

export const startCommandGetNbrCaPaperByFrequency = payload => {
  return {
    type: "START_COMMAND_GET_NBR_CA_PAPER_BY_FREQUENCY",
    payload
  };
};

export const startCommandGetNbrInscritBySilot = payload => {
  return {
    type: "START_COMMAND_GET_NBR_INSCRIT_BY_SILOT",
    payload
  };
};

export const startCommandGetSilotDetails = payload => {
  return {
    type: "START_COMMAND_GET_SILOT_DETAILS",
    payload
  };
};


// WEBPACK FOOTER //
// ./app/actions/actions/statistics.js